import React from 'react'
import { useIntersectionObserver } from 'react-intersection-observer-hook'

import LoadingState from './LoadingState'
import EmptyDataState from './EmptyState'
import Card from './Card'
import { EmptyState, EmptyStateAction } from '../components/EmptyState'
import BottomNav from '../components/BottomNav'
import { OfflineNotice } from 'components/OfflineNotice'
import { useMyAssesmentAPI } from 'api/assessment/useAPIAssessment'
import { useOnlineStatus } from 'utils/hooks/useOnlineStatus'
import { assetUrl } from 'utils/url'

export default function MyAssessmentList() {
  const isOnline = useOnlineStatus()
  const [ref, { entry }] = useIntersectionObserver()
  const limit = 20
  const { status, data, fetchNextPage, hasNextPage } = useMyAssesmentAPI(limit)

  React.useEffect(() => {
    if (entry && entry.isIntersecting) {
      fetchNextPage()
    }
  }, [entry, fetchNextPage])

  return (
    <div
      className="bg-[#f8f8f8] mt-[3.5rem] overflow-x-hidden"
      style={{ minHeight: 'calc(100vh - 7rem)' }}
    >
      {isOnline ? (
        <>
          {status === 'loading' && (
            <div className="pb-28 p-4">
              <LoadingState />
            </div>
          )}
          {status === 'success' && (
            <div className="pb-28 p-4">
              {data.pages[0].data.length === 0 && <EmptyDataState />}
              {data.pages.map((page) =>
                page.data.map((item) => (
                  <Card
                    key={item.id}
                    className="mb-3"
                    data={item}
                    showLearningGroup
                  />
                ))
              )}
              {hasNextPage && (
                <div className="text-center py-4" ref={ref}>
                  <img
                    src={assetUrl('/icon/circle-loading-blue.svg')}
                    alt=""
                    loading="lazy"
                    className="animate-spin inline-block w-6 h-6 mr-3"
                  />
                </div>
              )}
            </div>
          )}
          {status === 'error' && (
            <div
              className="flex flex-col"
              style={{ height: 'calc(100vh - 7rem)' }}
            >
              <EmptyState
                title="Gagal Memuat Asesmen Saya"
                subtitle="Maaf, ada masalah pada sistem kami. Mohon coba lagi."
              >
                <EmptyStateAction onClick={() => window.location.reload()}>
                  Coba Lagi
                </EmptyStateAction>
              </EmptyState>
            </div>
          )}
        </>
      ) : (
        <OfflineNotice className="absolute top-1/2 transform -translate-y-1/2" />
      )}
      <BottomNav />
    </div>
  )
}
